export function VisaTranslucent(className: string) {
  return (
    <svg
      className={className}
      version="1.1"
      viewBox="0 0 55 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.9592 18.2484H19.5789L22.3186 1.30762H26.6988L23.9592 18.2484Z"
        fill="white"
      />
      <path
        d="M39.8396 1.72124C38.9756 1.37846 37.6052 1 35.9108 1C31.585 1 28.5388 3.30671 28.5202 6.60462C28.4842 9.03781 30.7011 10.3893 32.3592 11.2006C34.0539 12.0296 34.63 12.5707 34.63 13.3097C34.6127 14.4446 33.2605 14.9677 31.9994 14.9677C30.2506 14.9677 29.3135 14.698 27.8895 14.0666L27.3127 13.7959L26.6997 17.5988C27.7271 18.0668 29.6199 18.4822 31.585 18.5004C36.1812 18.5004 39.1734 16.2293 39.2089 12.7149C39.2264 10.7864 38.0558 9.30872 35.532 8.10123C34 7.3261 33.0617 6.80343 33.0617 6.01033C33.0797 5.28934 33.8553 4.55085 35.5847 4.55085C37.0088 4.51468 38.0551 4.85698 38.8477 5.19951L39.2439 5.3794L39.8396 1.72124Z"
        fill="white"
      />
      <path
        d="M45.6619 12.2469C46.0226 11.2737 47.4107 7.507 47.4107 7.507C47.3925 7.54317 47.7708 6.51581 47.9871 5.88511L48.2932 7.34483C48.2932 7.34483 49.1227 11.3999 49.3028 12.2469C48.6182 12.2469 46.5271 12.2469 45.6619 12.2469ZM51.0689 1.30762H47.6807C46.6358 1.30762 45.842 1.61374 45.3912 2.7132L38.8848 18.2482H43.4809C43.4809 18.2482 44.2376 16.1573 44.4003 15.707C44.9045 15.707 49.3756 15.707 50.0243 15.707C50.15 16.3017 50.547 18.2482 50.547 18.2482H54.6027L51.0689 1.30762Z"
        fill="white"
      />
      <path
        d="M15.9217 1.3103L11.6318 12.8623L11.1631 10.5194C10.37 7.81605 7.88265 4.87888 5.10693 3.41844L9.03625 18.2331H13.6684L20.5535 1.3103H15.9217Z"
        fill="white"
      />
      <path
        d="M7.64701 1.3103H0.599443L0.527344 1.6526C6.02489 3.05842 9.6658 6.44711 11.1617 10.5201L9.62964 2.73433C9.37741 1.65236 8.60227 1.34599 7.64701 1.3103Z"
        fill="#FAFAFA"
      />
    </svg>
  );
}
